import React from 'react';
import { useCommandeContext, changeValeur } from "../contexts/CommandeContext";
import { Grid, Typography } from '@mui/material';
import CardPaiement from './cards/CardPaiement';


export default function CommandeTypePaiement({ disabled }) {

	// Recupération de la commande et du dispatcher à partir du CommandeContext
	const { commande, dispatch } = useCommandeContext();

	const handleSelectTypePaiement = (typePaiement, tarif) => {
		dispatch(changeValeur('typePaiement', typePaiement));
		dispatch(changeValeur('tarif', tarif));
	}

	return (
		<Grid container justifyContent="center">

			<Grid item xs={12}>
				<Typography id="titrePaiement" component="h3" sx={{ color: '#004afe', fontSize: { xs: 26, sm: 26, md: 36, lg: 36 }, fontWeight: 400, textAlign: 'center', my: 2, mt: 3 }}>
					Sélection du type de paiement
				</Typography>
			</Grid>

			{commande.produit.paiementImmediat &&
				<Grid item xs={12} md={5} sx={{ px: 2, pb: 2 }}>
					<CardPaiement
						selected={commande.typePaiement === 'PAIEMENT_IMMEDIAT'}
						disabled={disabled}
						desc={{
							type: "PAIEMENT_IMMEDIAT",
							titre: 'Paiement immédiat'
						}}
						tarif={commande.creneau.tarifs.PAIEMENT_IMMEDIAT}
						tarifRef={commande.creneau.tarifs.PAIEMENT_2FOIS.montantTotal}
						montantRemise={commande.remise !== undefined ? commande.remise.montantReduction : 0}
						displayPrix={commande.produit.displayPrix}
						actionSelectTypePaiement={handleSelectTypePaiement}
					/>
				</Grid>
			}
			
			{commande.produit.paiement2fois &&
				<Grid item xs={12} md={5} sx={{ px: 2, pb: 2 }}>
					<CardPaiement
						selected={commande.typePaiement === 'PAIEMENT_2FOIS'}
						disabled={disabled}
						desc={{
							type: "PAIEMENT_2FOIS",
							titre: 'Paiement en 2x'
						}}
						tarif={commande.creneau.tarifs.PAIEMENT_2FOIS}
						tarifRef={commande.creneau.tarifs.PAIEMENT_2FOIS.montantTotal}
						montantRemise={commande.remise !== undefined ? commande.remise.montantReduction : 0}
						displayPrix={commande.produit.displayPrix}
						actionSelectTypePaiement={handleSelectTypePaiement}
					/>
				</Grid>
			}
			
			{commande.produit.paiementIntervention &&
				<Grid item xs={12} md={8} sx={{ px: 2, pb: 2 }}>
					<CardPaiement
						selected={commande.produit.paiementIntervention}
						disabled={disabled}
						desc={{
							type: "PAIEMENT_INTERVENTION",
							titre: 'Paiement le jour de l\'intervention'
						}}
						tarif={commande.creneau.tarifs.PAIEMENT_IMMEDIAT}
						tarifRef={commande.creneau.tarifs.PAIEMENT_IMMEDIAT.montantTotal}
						montantRemise={commande.remise !== undefined ? commande.remise.montantReduction : 0}
						displayPrix={commande.produit.displayPrix}
						actionSelectTypePaiement={handleSelectTypePaiement}
					/>
				</Grid>
			}
			
		</Grid>
	);
}